import { useContext } from 'react';
import { ListItem, UnorderedList } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useUser } from 'contexts';
import { specialFont } from 'constants/theme';
import pages from 'constants/pages';
import { removeStorageItem } from 'utils/helpers';
import { ThemeContext } from 'contexts/themeContext';
import { Button, Link } from 'components/UI';
import AppRoutes from 'constants/routes';

type NavItemProps = {
  route: string;
  children: React.ReactNode;
};

const NavItem = ({ route, children }: NavItemProps) => (
  <ListItem>
    <Link
      sx={{
        fontFamily: specialFont,
        fontSize: 13,
        color: 'base1FontColour.500',
        textTransform: 'uppercase',
        textDecoration: 'none',
        _hover: {
          textDecoration: 'none',
        },
      }}
      to={route}
    >
      {children}
    </Link>
  </ListItem>
);

const Navigation = () => {
  const [user, setUser] = useUser();
  const navigate = useNavigate();
  const settings = useContext(ThemeContext);
  const isRFQ = settings?.rfqMode === 'true';

  const renderNav = pages
    .filter(({ id }) => (user?.role?.pages ?? []).includes(id))
    .map(({ id, text, render, ...item }) => (
      <NavItem key={id} {...item}>
        {render?.({ isRFQ }) ?? text}
      </NavItem>
    ));

  const handleLogout = () => {
    setUser(undefined);
    removeStorageItem('variant-token');

    navigate(AppRoutes.Landing);
  };

  return (
    <UnorderedList
      sx={{
        display: 'flex',
        flexDirection: 'row',
        listStyleType: 'none',
        alignItems: 'center',
        gap: 5,
      }}
    >
      <NavItem route={AppRoutes.Landing}>CONFIGURATOR</NavItem>
      {renderNav}
      <ListItem>
        <Button
          variant="unstyled"
          onClick={handleLogout}
          sx={{
            h: 'auto',
            fontSize: 13,
            letterSpacing: 'normal',
            p: 0,
            color: 'base1FontColour.500',
            _focus: {
              boxShadow: 'none',
            },
          }}
        >
          SIGN OUT
        </Button>
      </ListItem>
    </UnorderedList>
  );
};

export default Navigation;
